export default __webpack_public_path__ + "static/media/p1_xplaUpdate_bg.4f527d12.png";